// extracted by mini-css-extract-plugin
export default {"inputText":"style_inputText__rp4mX","error":"style_error__iDrni","passwordInput":"style_passwordInput__+fhaH","errorMessage":"style_errorMessage__ZruTT"};